import { createContext, useContext } from "react";

import { ProgressModalState } from "../types";

interface ExportContextInterface {
  exportProgressState: ProgressModalState;
  setExportProgressState: (
    value:
      | ProgressModalState
      | ((prev: ProgressModalState) => ProgressModalState),
  ) => void;
  exportInProgress: boolean;
  setExportInProgress: (value: boolean | ((prev: boolean) => boolean)) => void;
}

const emptyProgressModalState: ProgressModalState = {
  shouldOpen: false,
  title: "",
};

const defaultExportState = {
  exportProgressState: emptyProgressModalState,
  setExportProgressState: (): ProgressModalState => emptyProgressModalState,
  exportInProgress: false,
  setExportInProgress: (): boolean => false,
};

const ExportContext = createContext<ExportContextInterface>(defaultExportState);

export const useExportContext = (): ExportContextInterface =>
  useContext(ExportContext);

export default ExportContext;
